export const appConfig = {
  appName: "mesh-trivia",
  storagePrefix: "mesh-trivia",
  description:
    "Peer-to-peer mesh trivia. Drop a JSON pack, share a room, and tap answers in sync across every phone.",
  accentHex: "#a07fed",
  version: __APP_VERSION__,
  commit: __GIT_COMMIT__,
  repositoryUrl: "https://github.com/baditaflorin/mesh-trivia",
  pagesUrl: "https://baditaflorin.github.io/mesh-trivia/",
  signalingUrl:
    (import.meta.env.VITE_WEBRTC_SIGNALING as string | undefined) ?? "wss://turn.0docker.com/ws",
  turnTokenUrl:
    (import.meta.env.VITE_TURN_TOKEN_URL as string | undefined) ??
    "https://turn.0docker.com/credentials",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
} as const;
